import React from "react";

export enum AdmissionResponseType {
  OfferAccepted,
  OfferRejected,
  SimplifiedProcessJoin,
}

export function useAdmissionResponseSuccess() {
  const [isSuccessDialogOpen, setIsSuccessDialogOpen] = React.useState(false);
  const [admissionResponseType, setAdmissionResponseType] = React.useState(
    AdmissionResponseType.OfferAccepted
  );

  function showSuccessDialogAndRedirect(
    admissionResponseType: AdmissionResponseType,
    url: string
  ) {
    setAdmissionResponseType(admissionResponseType);
    setIsSuccessDialogOpen(true);
    const twoSecondsInMillis = 2000;
    setTimeout(() => {
      window.location.assign(url);
    }, twoSecondsInMillis);
  }

  return {
    showSuccessDialogAndRedirect,
    isSuccessDialogOpen,
    admissionResponseType,
  };
}
